<template>
  <div class='wrapping'>
    <x-payment-result-pc msg="Purchase Failed" isSuccess="false" v-if="deviceType==='pc'" ></x-payment-result-pc>
    <x-payment-result-mobile msg="Purchase Failed" isSuccess="false" v-if="deviceType==='mobile'" ></x-payment-result-mobile>
  </div>
</template>

<script>
import { isPC } from '@/util/index'
import PaymentResultPc from '@/views/recharge/components/result/pc'
import PaymentResultMobile from '@/views/recharge/components/result/mobile'

export default {
  name: 'PaymentFailure',
  components: {
    'x-payment-result-pc': PaymentResultPc,
    'x-payment-result-mobile': PaymentResultMobile
  },
  created () {
    this.initEnv()
  },
  data () {
    return {
      deviceType: ''
    }
  },
  methods: {
    // 初始过环境
    initEnv () {
      if (isPC()) {
        this.deviceType = 'pc'
      } else {
        this.deviceType = 'mobile'
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/recharge/failure.vue